import React from 'react';
import { Reveal } from '../Reveal';
import { BrowserMockup } from '../home/BrowserMockup';
import { MobileMockup } from '../home/MobileMockup';
import type { Project } from '../../types/content';
interface MockupShowcaseProps {
  project: Project;
  caption: string;
}
export function MockupShowcase({
  project,
  caption
}: MockupShowcaseProps) {
  return <figure data-id="element-202" data-mp="1enfiqcm0zlxx">
      <Reveal data-id="element-203" data-mp="1en5rklp8v8qn">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end lg:gap-10" data-id="element-204" data-mp="10q0mop19ofwz">
          <div className="lg:col-span-9" data-id="element-205" data-mp="10s3p68jlw1il">
            <BrowserMockup image={project.screenshot} alt={`${project.client} — desktop design, full page`} viewportAspect="aspect-[16/10]" data-id="element-206" data-mp="15p3sibp2mq60" />
          </div>
          <div className="mx-auto w-[58%] sm:w-[42%] lg:col-span-3 lg:mx-0 lg:w-full" data-id="element-207" data-mp="vrphirlx2tl3">
            <MobileMockup image={project.screenshot} alt={`${project.client} — mobile design`} data-id="element-208" data-mp="2m2u0vun840lg" />
          </div>
        </div>
      </Reveal>
      <figcaption className="mt-6 text-small text-muted" data-id="element-209" data-mp="1cu07pq1pedw7">{caption}</figcaption>
    </figure>;
}